import GalleryItem from "gallery/GalleryItem";
import VideoItemModal from "./VideoItemModal";


class GalleryItemVideo extends GalleryItem {


    getImageUrl(size = '2' /* Thumbnail */) {
        return this.data.customData.thumbnail;
    }

    getElementClasses() {
        return 'admin-gallery__item--video '
    }

    getModal(settings = {}) {
        return new VideoItemModal(this, settings);
    }
}


export {GalleryItemVideo as default};
